import React from 'react';
import { createUseStyles } from 'react-jss';
import { useDialog } from '../../../hooks/useDialog';
import { useTranslation } from 'react-i18next';
import { Button } from '../../Common/Button';
import loseImage from '../../../assets/images/lose.png';

const useStyles = createUseStyles({
    dialog: {
        maxHeight: 800,
        width: '70%',
        padding: '0.5rem 1rem',
        border: '1px solid black',
        backgroundColor: '#f5e7ec',
        flexDirection: 'column',
        '&:modal': {
            display: 'flex',
        },
    },
    root: {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'grid',
        gap: '1rem',
        gridTemplate: '"text image" "controls image" / 1fr 1fr',
    },
    title: {
        margin: 0,
    },
    text: {
        gridArea: 'text',
    },
    controls: {
        gridArea: 'controls',
        display: 'flex',
        flexDirection: 'column-reverse',
    },
    image: {
        gridArea: 'image',
        width: '300px',
    },
});
interface IWinDialogProps {
    days: number;
    onShowMenu(): void;
    onRetry(): void;
}

export const LoseDialog: React.FunctionComponent<IWinDialogProps> = (props) => {
    const styles = useStyles();
    const { t } = useTranslation();

    return <article className={styles.root}>
        <div className={styles.text}>
            <h2 className={styles.title}>{t('game.loseDialog.title')}</h2>
            <p>{t('game.loseDialog.text', { value: props.days })}</p>
        </div>
        <div className={styles.controls}>
            <Button onClick={props.onShowMenu}>{t('backToMenu')}</Button>
            <Button onClick={props.onRetry}>{t('retry')}</Button>
        </div>
        <img src={loseImage} alt={t('game.loseDialog.alt')} className={styles.image} />

    </article>;
};

export const useLoseDialog = (days: number, onShowMenu: () => void, onRetry: () => void) => {
    const styles = useStyles();
    return useDialog({
        children: <LoseDialog  days={days} onShowMenu={onShowMenu} onRetry={onRetry}/>,
        className: styles.dialog,
    });
};
